import { render, staticRenderFns } from "./all-ship.vue?vue&type=template&id=b5d6097c"
import script from "./all-ship.vue?vue&type=script&lang=js"
export * from "./all-ship.vue?vue&type=script&lang=js"
import style0 from "./all-ship.vue?vue&type=style&index=0&id=b5d6097c&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports